import { atom } from "recoil";

export const achievementEditModalStore = atom({
	key: "achievementEditModalStore",
	default: {
		show: false,
		loaded: true,
		name: "",
		description: "",
		category_id: null,
		type: "",
		rewardType: "",
		rewardValue: "",
		chestRewards: [],
		chestType: "",
		chestPrizeId: null,
		chestPrizeSelected: null,
		chestPrizeOptions: [],
		chestPrizeLoading: false,
		chestPrizeMatchMissing: false,
		reward_tickets: "",
		image: "",
		link: "",
		active: "",
		categories: [],
	},
});
